import * as Types from '../../../../../graphql.generated';

export type SigninUserMutationVariables = Types.Exact<{
    input: Types.SigninUserInput;
}>;

export type SigninUserMutation = { __typename?: 'Mutation' } & {
    signinUser?: Types.Maybe<
        { __typename?: 'SigninUserPayload' } & Pick<
            Types.SigninUserPayload,
            'success' | 'errorCode' | 'errorMessage'
        >
    >;
};

export const SigninUserDocument = `
    mutation signinUser($input: SigninUserInput!) {
  signinUser(input: $input) {
    success
    errorCode
    errorMessage
  }
}
    `;
export type Requester<C = {}> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C>(requester: Requester<C>) {
    return {
        signinUser(
            variables: SigninUserMutationVariables,
            options?: C
        ): Promise<SigninUserMutation> {
            return requester<SigninUserMutation, SigninUserMutationVariables>(
                SigninUserDocument,
                variables,
                options
            );
        }
    };
}
export type Sdk = ReturnType<typeof getSdk>;
